// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__ryzda","colMaxWidth":"Table_colMaxWidth__1pm2S"};